import { useTranslation } from "react-i18next";

/** Returns localized {name, description} for a product, falling back to English. */
export function useProductCopy(product) {
    const { i18n } = useTranslation();
    const lang = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
    const name = product?.name_i18n?.[lang] || product?.name || "";
    const description = product?.description_i18n?.[lang] || product?.description || "";
    return { name, description };
}
